export { default as BaraVaultAbi } from './baraVault.json';
export { default as ERC20 } from './ERC20.json';
export { default as WCRO } from './WCRO.json';
